import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AdminRoute = ({ children, allowedRoles = [] }) => {
  const { userProfile, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="auth-loading" style={{display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: '#05070a'}}>
        <div className="spinner"></div>
        <p style={{color: 'var(--v7-cyan)', marginLeft: '15px'}}>AUTHENTICATING_SENTINEL_NODE...</p>
      </div>
    );
  }

  // 1. Authenticated Check
  if (!userProfile) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  // 2. Sovereign Node Check (Must have a record in admins/ collection)
  if (!userProfile.isAdmin) {
    return <Navigate to="/admin/login" replace />;
  }

  // 3. Status Check
  if (userProfile.status === 'suspended' || userProfile.status === 'pending') {
    return (
      <div className="admin-access-denied" style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', textAlign: 'center', background: '#05070a', color: '#fff'}}>
        <i className="fa-solid fa-user-lock" style={{fontSize: '4rem', color: '#ff375f', marginBottom: '20px'}}></i>
        <h1>Node Access Suspended</h1>
        <p style={{color: '#8b949e'}}>Your administrative credentials have been revoked or are currently pending ROOT_SENTINEL review.</p>
        <button className="btn btn-secondary" onClick={() => window.location.href = '/'} style={{marginTop: '20px'}}>Return to Origin</button>
      </div>
    );
  }

  // 4. RBAC Check (Permission Tiers)
  if (allowedRoles.length > 0 && !allowedRoles.includes(userProfile.role)) {
    return (
      <div className="admin-access-denied" style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', textAlign: 'center', background: '#05070a', color: '#fff', padding: '20px'}}>
        <i className="fa-solid fa-triangle-exclamation" style={{fontSize: '4rem', color: '#ffb020', marginBottom: '20px'}}></i>
        <h2 style={{color: '#ffb020'}}>Insufficient Privileges</h2>
        <p style={{color: '#8b949e', maxWidth: '500px'}}>Your role tier ({userProfile.role?.toUpperCase()}) does not have execution permission for this node. Access to this sector is restricted to: {allowedRoles.join(', ').toUpperCase()}.</p>
        <button className="btn btn-secondary" onClick={() => window.history.back()} style={{marginTop: '20px'}}>Request Clearance (Back)</button>
      </div>
    );
  }

  return children;
};

export default AdminRoute;
